import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const useInitDatadog = () => {
  useEffect(() => {
    datadogRum.init({
      applicationId: 'c7d873ce-372c-4f83-b1cf-c83869987d53',
      clientToken: 'pub0712aaa8586240d737b9416781bdccdb',
      site: 'us5.datadoghq.com',
      service: 'aqxtrader-web',
      env: 'prod',
      version: '3.4.8-42a68cf01',
      allowedTracingUrls: [
        (url) => {
          const urlObj = new URL(url);
          return urlObj.host === window.location.host;
        }
      ],
      traceSampleRate: 25,
      sessionSampleRate: 25,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackSessionAcrossSubdomains: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: false })]
    });

    datadogLogs.init({
      clientToken: 'puba43074bd12e6f5acb96dc0d1612145a8',
      site: 'us5.datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 25
    });
  }, []);
};
